import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
import { notify } from '../../../common/functions/react-toastify.function';

export const deletePurchaseOrder = async (id, po) => {
  try {
    const response = await apiClient.delete(
      `/adminInvoiceManagement/purchaseOrderManagement/${id}/${po}`
    );

    if (response.status === 200 || response.status === 201) {
      // Handle the response structure: { status, message, response }
      return {
        success: true,
        data: response.data?.response || response.data?.data || response.data,
        message: response.data?.message || 'PO record deleted successfully',
      };
    } else {
      const errorMessage = response.data?.error || 'Failed to delete purchase order';
      notify('error', errorMessage);
      return { success: false, error: errorMessage };
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.error || error.message || 'Failed to delete purchase order';
    handleApiError(error);
    notify('error', errorMessage);
    return { success: false, error: errorMessage };
  }
};
